import React, { useRef, useEffect, useState } from "react";
import Media from "@qlik/qlik/src/components/Media";
import closeIcon from "@qlik/qlik/src/assets/images/search-close.svg";
import SubmenuLevelThreeWhyQlik from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Two/Why_Qlik";
import SubmenuLevelThreeProducts from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Two/Products";
import SubmenuLevelThreeSolutions from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Two/Solutions";
import SubmenuLevelThreePricing from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Two/Pricing";
import SubmenuLevelThreeLearn from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Two/Learn";
import { LAYOUT_LINK_ONLY } from "@qlik/qlik/src/lib/constants/menu-layout-names";

/**
 * See <Header> component's doc comment
 */
const renderSubMenuLevelThreeComponent = (menuItem, activeMenu, setHasSubItems, hasSubItems) => {
    const menuType = menuItem.itemName;

    switch (menuType) {
        case "Page - Why Qlik":
            return (
                <SubmenuLevelThreeWhyQlik
                    key={menuItem.id}
                    data={menuItem}
                    activeMenu={activeMenu}
                    hasSubItems={hasSubItems}
                    setHasSubItems={setHasSubItems}
                />
            );
        case "Page - Products":
            return (
                <SubmenuLevelThreeProducts
                    key={menuItem.id}
                    data={menuItem}
                    activeMenu={activeMenu}
                    hasSubItems={hasSubItems}
                    setHasSubItems={setHasSubItems}
                />
            );
        case "Page - Solutions":
            return (
                <SubmenuLevelThreeSolutions
                    key={menuItem.id}
                    data={menuItem}
                    activeMenu={activeMenu}
                    hasSubItems={hasSubItems}
                    setHasSubItems={setHasSubItems}
                />
            );
        case "Page - Pricing":
            return (
                <SubmenuLevelThreePricing
                    key={menuItem.id}
                    data={menuItem}
                    activeMenu={activeMenu}
                    hasSubItems={hasSubItems}
                    setHasSubItems={setHasSubItems}
                />
            );
        case "Page - Learn":
            return (
                <SubmenuLevelThreeLearn
                    key={menuItem.id}
                    data={menuItem}
                    activeMenu={activeMenu}
                    hasSubItems={hasSubItems}
                    setHasSubItems={setHasSubItems}
                />
            );
        default:
            return null;
    }
};

/**
 * useOutsideClick is a hook to detect clicks outside of a component
 */
const useOutsideClick = (callback) => {
    const ref = useRef();

    useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [callback, ref]);

    return ref;
};

/**
 * See <Header> component's doc comment
 */
const Dropdowns = ({ mainMenu, activeLink, setActiveLink }) => {
    const activeLinkItem = activeLink;

    // Use this boolean to slightly alter the CSS for 2nd level items that don't have 3rd level items
    const [hasSubItems, setHasSubItems] = useState(true);

    // We need to explicitly check if the 1st item in the dropdown has 3rd leve items
    // and then set the "hasSubItems" value depending on this.
    useEffect(() => {
        const activeMenuItem = mainMenu.menuItems.find((menuItem) => menuItem.id === activeLink);

        // Check if the 1st subItem.itemName === "Layout - Link Only"
        const isLayoutLinkOnly = activeMenuItem?.subItems?.[0].itemName === LAYOUT_LINK_ONLY;
        setHasSubItems(activeMenuItem?.subItems?.length > 0 && !isLayoutLinkOnly);
    }, [activeLink, mainMenu]);
    /* submenu close event handler */
    const closeSubmenu = () => {
        setActiveLink("");
    };

    const dropdownRef = useOutsideClick(closeSubmenu);

    return (
        <div className="dropDowns">
            <div
                className={`dropdownWrapper -z-1 xl:z-1 absolute top-full inset-x-0 ${
                    hasSubItems ? "bg-white" : "bg-stone-light"
                }  border-t border-t-stone/50 transition-transform ease-linear duration-200 xl:overflow-auto xl:max-h-[calc(100dvh-118px)] ${
                    activeLinkItem ? "xl:translate-y-0" : "xl:-translate-y-3"
                }`}
            >
                <div ref={dropdownRef} className="relative contain-paint">
                    <div className="container relative">
                        <div className="row">
                            <div className="cl-12">
                                {/* Loop through the submenus */}
                                {mainMenu?.menuItems?.map((menuItem) =>
                                    renderSubMenuLevelThreeComponent(
                                        menuItem,
                                        activeLinkItem,
                                        setHasSubItems,
                                        hasSubItems
                                    )
                                )}
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={closeSubmenu}
                            className={`menuCloseIcon absolute top-10 -right-15 hover:opacity-60 transition-all ease-in-out`}
                            aria-label="Close search"
                        >
                            <Media link={closeIcon} />
                        </button>
                    </div>
                </div>
            </div>
            <button
                onClick={closeSubmenu}
                className={`-z-2 absolute inset-x-0 top-full w-full h-screen bg-gray/90 ${
                    activeLinkItem ? "block" : "hidden"
                }`}
            />
        </div>
    );
};

export default Dropdowns;
